import { render, staticRenderFns } from "./testchat.vue?vue&type=template&id=3e0d5699&"
import script from "./testchat.vue?vue&type=script&lang=js&"
export * from "./testchat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports